export default __webpack_public_path__ + "static/media/astronaut.17055b5f.png";